import type { LayoutNode } from '@vedalib/editor'
import { DeviceMode } from '@vedalib/editor'
import { useMemo } from 'react'

import FieldLayoutActiveUsers from 'components/Editor/Toolbar/NodeForm/FieldLayoutActiveUsers'
import type { IFieldConfig } from 'components/formKit'
import type { FieldUseConfigType } from 'components/formKit/types'
import { EMPTY_OBJECT } from 'constants/commonConstans'
import LabelResetInherit from 'services/Branding/components/LabelResetInherit'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getDeviceMode } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'

type PartialProps = '__type' | 'setter' | 'getter' | 'effect'
type IFieldConfigHelper<D, P, N extends string = string> = Omit<
  IFieldConfig<D, P, N>,
  PartialProps
> &
  Partial<IFieldConfig<D, P, N>>

// TODO: add realtime layout
export const genElementValueField = <P>(config: IFieldConfigHelper<Block, P>) =>
  ({
    ...config,
    layoutRender: FieldLayoutActiveUsers,
    __type: 'UIField',
  }) as IFieldConfig

export const genNodeField = <P>(config: IFieldConfigHelper<LayoutNode, P>) =>
  ({
    ...config,
    layoutRender: FieldLayoutActiveUsers,
    useConfigs: [useLabelResetInherit, ...(config.useConfigs || [])],
    __type: 'UIField',
  }) as IFieldConfig

export const useLabelResetInherit: FieldUseConfigType = () => {
  const device = useProjectContext(getDeviceMode)

  return useMemo(
    () => (device !== DeviceMode.desktop ? { labelRender: LabelResetInherit } : EMPTY_OBJECT),
    [device],
  )
}
